import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

const ExtensionsCell: FC<Props> = () => {

  return (
    <div className={styles.wrapper}>
      <div className={styles.extensions}>
        <div className={styles.drop}>
          +0 <FontAwesomeIcon icon={faCaretDown}></FontAwesomeIcon>
        </div>
      </div>
    </div>
  );
};

export default ExtensionsCell;
